import React from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { EXPERTISE, SKILLS } from "../../data";

export const Expertise = () => {
  return (
    <section id="expertise" data-testid="expertise-section" className="py-24 lg:py-36 bg-navy text-white relative overflow-hidden">
      <div className="mx-auto max-w-7xl section-x relative z-10">
        <p className="label-caps text-berry-light mb-4">Expertise</p>
        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight max-w-2xl">
          What I bring to the finance function
        </h2>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-sm overflow-hidden">
          {EXPERTISE.map((e, i) => {
            const Icon = e.icon;
            return (
              <motion.div
                key={e.title}
                data-testid={`expertise-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-navy hover:bg-navy-800 transition-colors duration-300 p-8 lg:p-9 group"
              >
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-sm bg-berry/20 text-berry-light mb-6 group-hover:bg-berry group-hover:text-white transition-colors duration-300">
                  <Icon size={22} />
                </span>
                <h3 className="font-serif text-xl mb-3">{e.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{e.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>

      <div className="mt-20 lg:mt-28 border-y border-white/10 py-8">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {SKILLS.map((s) => (
            <span key={s} className="font-serif text-3xl lg:text-5xl text-white/25 mx-8 uppercase tracking-wide flex items-center gap-8">
              {s}
              <span className="w-2 h-2 bg-berry rotate-45 inline-block" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
